module.exports = __webpack_public_path__ + "static/media/tær.143ed125.mp3";